import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const FindWordsStepOneExtraCollections = ({
  findWordsStepOneExtraCollections,
  findWordsStepOneExtraCurrency,
  getCollections,
  hasLoaded,
  pageCount,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="find-words-collections-container--step-one-extra"
      collectionsPath={paths.FIND_WORDS_STEP_ONE_EXTRA}
      currency={findWordsStepOneExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={findWordsStepOneExtraCollections}
      levelsPath={paths.FIND_WORDS_STEP_ONE_EXTRA_LEVELS}
      pageCount={pageCount}
      student={student}
      title={messages.game.findWords}
    />
  );
};

FindWordsStepOneExtraCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  findWordsStepOneExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  findWordsStepOneExtraCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.findWordsStepOneExtraCollections.getHasLoaded(state),
  findWordsStepOneExtraCurrency: selectors.findWordsStepOneExtraCollections.getCurrencyData(
    state
  ),
  findWordsStepOneExtraCollections: selectors.findWordsStepOneExtraCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.findWordsStepOneExtraCollections.getPageCount(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.findWordsStepOneExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(FindWordsStepOneExtraCollections);
